// extracted by mini-css-extract-plugin
export default {"lottie":"entry-main-image_lottie__chIxo","lottie-player":"entry-main-image_lottie-player__Hhnqr"};